import { forEach, filter, remove, slice, includes, find, findIndex } from 'lodash';
import app from '../../angular_app.es6';

app.controller('AddingFlavorController',
  [ '$scope', 'Notification', '$timeout', '$http', '$interval', '$rootScope', 'PasteTableService',
    ($scope, Notification, $timeout, $http, $interval, $rootScope, PasteTableService) => {
      let checkEvery5s = null;
      $scope.checkInterval = 5000;

      // $scope.newClaim = {};
      // $scope.newImage = {};
      $scope.newObject = {};

      $scope.form = {};
      $scope.source_form = {};

      $scope.options = {
        possible_concepts_modes: []
      };

      $scope.makeForm = (data) => {
        const isSeq = includes($scope.options.sequential_list, data.concepts_mode);

        let express_objects;

        if (isSeq) {
          express_objects = data.express_images.map((el) => {
            el.imageId = el.id;
            return el;
          });
        } else {
          express_objects = data.express_claims.map((el) => {
            el.claimId = el.id;
            el.name = el.text;
            return el;
          });
        }

        return {
          id: data.id,
          items_to_evaluate: parseInt(data.items_to_evaluate),
          concepts_mode: data.concepts_mode,
          concepts_num: data.concepts_num,
          express_objects,
          express_images: data.express_images,
          express_claims: data.express_claims
        };
      };

      $scope.init = (data, options, notification) => {
        $scope.options = options;
        $scope.source_form = $scope.makeForm(data);
        $scope.form = angular.copy($scope.source_form);
        $scope.notification = notification;
        $scope.asyncGenerateJID = $scope.options.jid;

        if ($scope.asyncGenerateJID) {
          checkEvery5s = $interval($scope.checkAsyncGenerate, $scope.checkInterval);
          $rootScope.$broadcast('disableNavButtons');
        }

        if ($scope.notification) {
          Notification.error($scope.notification);
        }

        $scope.refreshNewObject();
      };

      $scope.maxToUpload = () => (Math.abs($scope.notDeletedObjects().length - $scope.form.items_to_evaluate));

      $scope.currentModeLabel = () => ($scope.options.mode_labels[$scope.form.concepts_mode]);
      $scope.isCurrentModeMaxDiff = () => ($scope.form.concepts_mode === 'maxdif' || $scope.form.concepts_mode === 'maxdif_turf');


      $scope.notDeletedObjects = () => (
        filter($scope.form.express_objects, (obj) => !obj._destroy)
      );

      $scope.withoutPhantomObjects = (idField) => (
        filter(
          $scope.form.express_objects,
          (obj) => (!!obj[idField] || !obj._destroy)
        )
      );
      $scope.oldImagesToDestroy = () => (
        filter(
          $scope.form.express_images,
          (image) => (
            !!image.id &&
            !find($scope.withoutPhantomObjects('imageId'), (item) => item.imageId == image.id)
          )
        )
      );
      $scope.oldClaimsToDestroy = () => (
        filter(
          $scope.form.express_claims,
          (claim) => (
            !!claim.id &&
            !find($scope.withoutPhantomObjects('claimId'), (item) => item.claimId == claim.id)
          )
        )
      );

      $scope.hasLabelError = (claim) => {
        return claim.errors && !!claim.errors.label;
      };

      $scope.hasTextError = (claim) => {
        return claim.errors && !!claim.errors.text;
      };

      $scope.addObject = (event) => {
        event.preventDefault();
        $scope.form.express_objects.push($scope.newObject);
        $scope.refreshNewObject();
      };

      $scope.refreshNewObject = () => {
        $scope.newObject = {
          imageId: null,
          claimId: null,
          name: null,
          image_src: null,
          label: null
        };
      };

      $scope.destroyObject = (event, obj) => {
        if (event) {
          event.preventDefault();
        }

        if (!!obj.imageId || !!obj.claimId) {
          obj._destroy = true;
        } else {
          remove($scope.form.express_objects, obj);
        }
      };

      $scope.$on('xlsx-loaded', (ev, arr) => {
        if ($scope.isSequential()) {
          $scope.processFlavorsXlsx(arr);
        } else {
          $scope.processClaimsXlsx(arr);
        }
      });

      $scope.processFlavorsXlsx = (arr) => {
        const newElms = [];

        forEach(arr, (el) => {
          let text = el[arr.headerStatement];

          if (text) {
            text = text.toString();

            newElms.push(
              {
                name: slice(text, 0, $scope.options.max_text_len).join(''),
                image_src: null
              }
            );
          }
        });

        const toCopyCnt = $scope.form.items_to_evaluate - $scope.notDeletedObjects().length;

        if (toCopyCnt > 0) {
          $timeout(() => {
            forEach(
              slice(newElms, 0, toCopyCnt),
              (el) => {
                $scope.form.express_objects.push(el);
              }
            );
          });
        }
      };

      $scope.processClaimsXlsx = (arr) => {
        const newElms = [];

        forEach(arr, (el) => {
          let text = el[arr.headerStatement],
            label = el[arr.headerLabel];

          if (text) {
            label = label == undefined ? '' : label.toString();
            text = text.toString();

            newElms.push(
              {
                name: slice(text, 0, $scope.options.max_text_len).join(''),
                label: slice(label, 0, $scope.options.max_label_len).join('')
              }
            );
          }
        });

        const toCopyCnt = $scope.form.items_to_evaluate - $scope.notDeletedObjects().length;

        if (toCopyCnt > 0) {
          $timeout(() => {
            forEach(
              slice(newElms, 0, toCopyCnt),
              (el) => {
                $scope.form.express_objects.push(el);
              }
            );
          });
        }
      };

      $scope.isSequential = () => includes($scope.options.sequential_list, $scope.form.concepts_mode);
      $scope.openUploader = (event, parentPath, path) => {
        event.preventDefault();
        $(event.target).parents(parentPath).find(path).click();
      };

      $scope.removeExtension = (filename) => {
        return (filename || '').split('.').slice(0, -1).join('.');
      };

      $scope.nullifyImage = (flavor) => {
        let i;
        const keys = Object.keys(flavor);

        for (i = 0; i < keys.length; i++) {
          if (keys[i] !== 'id' && keys[i] !== 'name') {
            delete flavor[keys[i]];
          }
        }

        $timeout(() => {});
      };

      $scope.onUploadSuccess = (source) => {
        const source_json = JSON.parse(source['source_data']);
        source['name'] = $scope.removeExtension(source_json.metadata.filename);

        if (source_json.metadata.mime_type === "application/pdf") {
          $http.post(
            '/express/api/transformer',
            {
              project_id: $scope.form.id,
              source_data: source['source_data']
            }
          ).then(
            (response) => {
              watchConvertStatus(source, response.data.jid);
            },
            (response) => {
              Notification.error(response.data.error || response.statusText);
              $scope.destroyObject(null, source);
            }
          );
        } else {
          source['image_data'] = source['source_data'];
          source['image_src'] = source['preview_src'];
          Object.merge(source, { loading: false });
        }
      };

      $scope.sourceGenerator = () => {
        return {
          id: null,
          image_src: '#'
        };
      };

      $scope.imageBgStyle = (claim) => {
        if (claim.image_src) {
          return { 'background-image': `url(${claim.image_src})` };
        }
        return null;
      };

      $scope.onImageSelected = (claim) => (
        (file) => { claim.loading = true; }
      );

      $scope.onImageUploaded = (claim) => {
        if (!claim.onImageUploaded) {
          claim.onImageUploaded = (source) => {
            const source_json = JSON.parse(source['source_data']);
            if (source_json.metadata.mime_type === "application/pdf") {
              $http.post('/express/api/transformer', { project_id: $scope.form.id, source_data: source['source_data'] }).then(
                (response) => {
                  watchConvertStatus(source, response.data.jid);
                },
                (response) => {
                  Notification.error(response.data.error || response.statusText);
                  $scope.destroyObject(null, source);
                }
              );
            } else {
              source['image_data'] = source['source_data'];
              source['image_src'] = source['preview_src'];
              Object.merge(source, { loading: false });
            }
          };
        }

        return claim.onImageUploaded;
      };

      $scope.possibleConceptsModes = (n) => $scope.options.possible_modes_hash[n] || [];

      $scope.conceptsModeEnabled = (cm) => {
        return $scope.possibleConceptsModes($scope.form.items_to_evaluate).findIndex(cm) > -1;
      };

      $scope.items_to_evaluate_dirty = null;

      $scope.onITEChange = (newVal, oldValStr) => {
        const oldVal = parseInt(oldValStr);

        if (!newVal && !oldVal) {
          return;
        }

        if (
          !!$scope.form.concepts_mode && newVal != oldVal &&
          !$scope.conceptsModeEnabled($scope.form.concepts_mode)
        ) {
          $scope.form.items_to_evaluate = oldVal;
          $scope.items_to_evaluate_dirty = newVal;
          $('#confirmation').modal({});
        }
      };

      $scope.applyITE = () => {
        $scope.form.items_to_evaluate = $scope.items_to_evaluate_dirty;
      };

      // private

      $scope.checkAsyncGenerate = () => {
        $http.get($scope.options.check_status_url).then(
          (success) => {
            if (success.data.status === "finished") {
              $interval.cancel(checkEvery5s);
              $scope.asyncGenerateJID = null;
              window.location.href = $scope.options.next_step_url;
            } else if (success.data.status === "failed") {
              $scope.asyncGenerateJID = null;
              $interval.cancel(checkEvery5s);
              Notification.error("Project rebuilding failed.");
              $rootScope.$broadcast('enableNavButtons');
            }
          },
          (reject) => {
            $interval.cancel(checkEvery5s);
            $scope.asyncGenerateJID = null;
            console.log('checkAsyncGenerate', reject);
            $rootScope.$broadcast('enableNavButtons');
          }
        );
      };

      $scope.$on('project-form-next-step', (event) => {
        if ($scope.asyncGenerateJID) {
          event.preventDefault();
          Notification.error("Rebuilding in progress.");
          return;
        }

        const form = $('#adding_form');

        if (!$scope.source_form.concepts_mode) {
          form.submit();
        } else if (
          !trackChanges() && trackExisting() &&
          !$scope.notification &&
          $scope.conceptsModeEnabled($scope.form.concepts_mode)
        ) {
          event.preventDefault();
          window.location.href = $scope.options.next_step_url;
        } else if ($scope.notification) {
          form.submit();
        } else if (confirm($scope.options.change_structure_message)) {
          form.submit();
        }
      });

      const trackExisting = () => (
        !!filter(
          $scope.form.express_objects,
          (el) => (!!el.imageId || !!el.claimId)
        ).length
      );

      const trackChanges = () => (
        !angular.equals($scope.form, $scope.source_form)
      );

      const watchConvertStatus = (source, jid) => {
        (function tick() {
          $http.get(`/express/api/transformer/${jid}`).then(
            (response) => {
              const state = response.data.state;
              if (response.data.status === 'failed') {
                state.step = 'error';
                state.message = `Something went wrong while processing the '${source.name}' at the moment, please try again`;
              }

              switch (state.step) {
                case 'finished':
                  Object.merge(source, state.output);
                  Object.merge(source, { loading: false });
                  break;
                case 'error':
                  $scope.destroyObject(null, source);
                  Notification.error(state.message);
                  break;
                default:
                  $timeout(tick, 3000);
              }
            },
            (response) => {
              Notification.error(response.data.error || response.statusText);
            }
          );
        })();
      };

      $scope.onPaste = ($e, index) => {
        const lines = PasteTableService.extract($e);
        if (lines != null) {
          PasteTableService.apply(
            index,
            $scope.notDeletedObjects(),
            [ 'name', 'label' ],
            lines,
            $scope.form.express_objects,
            $scope.form.items_to_evaluate,
            () => ({ imageId: null, claimId: null, name: null, image_src: null, label: null }),
          );
        }
      };

      $scope.isLoading = () => (
        findIndex(
          ($scope.notDeletedObjects()),
          (obj) => obj.loading
        ) > -1
      );

      $scope.$watch('isLoading()', (newVal) => {
        if (!$scope.asyncGenerateJID) {
          if (newVal) {
            $rootScope.$broadcast('disableNavButtons');
          } else {
            $rootScope.$broadcast('enableNavButtons');
          }
        }
      });
    } ]);
